export default __webpack_public_path__ + "static/media/world.4541f33a.svg";